export default __webpack_public_path__ + "static/media/MyriadProSemiBold.f48a724d.ttf";